import axios, { AxiosResponse } from "axios";
import { Employee, InpuData } from "../models/settingModel";
import { WTADetailedData } from "../models/wtaModel";
import { InputDetail } from "../models/dashboard/newJoinerFeedbackModel";
import AuthHelper from "../helper/auth-helper";
import { DashboardModel } from "../models/dashboard/dashboardModel";
import { ActiveUsersCountModel } from "../models/dashboard/activeUsersCountModel";
import { logCustomError, logCustomInfo } from "../Services/TelemetryService";
import qs from "qs";
import { Constants } from "../helper/constants";
import { Utilities } from "../helper/Utility";
import { ReminderModel } from "../models/dashboard/reminderModel";
import { CheckBoxOverlayModel } from "../models/dashboard/checkBoxOverlayModel";
import { RecommendationDetailsModel } from "../models/recommendationDetailsModel";
import { WhatsOnYourMindModel } from "../models/dashboard/whatsOnYourMindModel";
import { viModel } from "../models/dashboard/viModel";
import { FeedbackModel } from "../models/dashboard/feedbackModel";
import { newJoinerJourneySurveyModel } from "../models/dashboard/newJoinerJourneySurveyModel";
import {
  gamificationWeeklyQuizModel,
  gamificationWeeklyQuizResponseModel,
} from "../models/Gamification/gamificationWeeklyQuizModel";
import { newJoinerChecklistModel } from "../models/dashboard/newJoinerChecklistModel";
import { RovApplyModel } from "../models/dashboard/RovApplyModel";
import { nthUserModel } from "../models/dashboard/nthUserModel";
import { individualTabDetailsRequestModel } from "../models/dashboard/individualTabDetailsRequestModel";
import { cohortTabDetailsRequestModel } from "../models/dashboard/cohortTabDetailsRequestModel";


export class ExternalApiService {
  static initialize() {
    var access_token = localStorage.getItem(Constants.AccessTokenKey);
    AuthHelper.CheckTokenExpiry(access_token, 1);

    //var HumanApi_token = localStorage.getItem(Constants.HumanApiTokenKey);
    //AuthHelper.CheckTokenExpiry(HumanApi_token, 0);

    axios.interceptors.request.use((config: any) => {
      //AuthHelper.AcquireTokenForResource();
      var token = localStorage.getItem(Constants.AccessTokenKey);
      Utilities.LogInfo(
        "token - for url -",
        "External-API.services.ts -> initialize"
      );
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });
    axios.interceptors.response.use(
      (res) => {
        return res;
      },
      async (err) => {
        const originalConfig = err.config;
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true;
          // Access Token expired
          try {
            //AuthHelper.getHumanApiToken();
            let accessToken = await AuthHelper.getRedirectToken();
            localStorage.setItem("Constants.AccessTokenKey", accessToken!);
            originalConfig.headers.Authorization = `Bearer ${accessToken}`;
            return axios(originalConfig);
          } catch (_error) {
            return Promise.reject(_error);
          }
        }
        return Promise.reject(err);
      }
    );
  }

  private static getHeaders(): any {
    return {
      "Content-Type": "application/json",
      "Cache-Control":
        "no-cache, no-store, must-revalidate, post- check=0, pre-check=0",
      Pragma: "no-cache",
      Expires: "0",
    };
  }

  public static async fetchWta(
    emailId: string
  ): Promise<WTADetailedData | null> {
    const response = await axios
      .get(process.env.REACT_APP_GETWTALIST!, {
        params: { enterpriseId: emailId },
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<WTADetailedData>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in fetchWta");
        return null;
      });

    return response;
  }

  public static async fetchUserSettings(
    emailId: string
  ): Promise<Employee | null> {
    const response = await axios
      .get(process.env.REACT_APP_GETSETTINGSPANEDETAILS!, {
        params: { enterpriseId: emailId },
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<Employee>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(JSON.stringify(error), "Error in fetchUserSettings");
        return null;
      });

    return response;
  }

  public static async updateUserSettings(
    inputbody: InpuData
  ): Promise<boolean | null> {
    const response = await axios
      .post(process.env.REACT_APP_UPDATENOTIFICATIONSETTINGS!, inputbody, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<boolean>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in updateUserSettings");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> updateUserSettings"
        );
        return false;
      });

    return response;
  }

  public static async updateRecommendationService(
    inputbody: InpuData
  ): Promise<boolean | null> {
    const response = await axios
      .post(process.env.REACT_APP_UPDATERECOMMENDATIONSERVICE!, inputbody, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<boolean>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in updateRecommendationService");
        return false;
      });

    return response;
  }

  public static async fetchLeftPaneData(
    dashboardModel: DashboardModel
  ): Promise<any | null> {
    const response = await axios
      .post(process.env.REACT_APP_APPLICATIONFLOWAPIURL!, dashboardModel, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        logCustomInfo("fetchLeftPaneData Success", {
          RequestId: dashboardModel.RequestId,
        });
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in fetchLeftPaneData", {
          RequestId: dashboardModel.RequestId,
        });
        return null;
      });
    return response;
  }

  
  public static async fetchNJBoardVisit(enterpriseId: string): Promise<any> {
    const response = await axios
      .post(
        process.env.REACT_APP_TRACKNEWJOINERDASHBOARDVISIT!,
        { EmployeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> fetchNJBoardVisit"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> fetchNJBoardVisit"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> fetchNJBoardVisit"
          );
        }
        return true;
      });
    return response;
  }

  public static async GetEmployeeDetails(enterpriseId: string): Promise<any> {
    const isTestUser = !!localStorage.getItem("extraUserData");
    const response = await axios
      .post(
        process.env.REACT_APP_GETEMPLOYEEDETAILS!,
        { EmployeeEnterpriseId: enterpriseId, IsTestUser: isTestUser },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> GetEmployeeDetails"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> GetEmployeeDetails"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> GetEmployeeDetails"
          );
        }
        return true;
      });
      return response;
    //  return {
    //   "doj": "2025-03-01T00:00:00-05:00"
    //  };
  }

  public static async getProfilePageData(
    enterpriseId: string,
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETPROFILEPAGEDATA!,
        {
          EmployeeEnterpriseId: enterpriseId,
          //tokenData: localStorage.getItem(Constants.HumanApiTokenKey),
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getProfilePageData");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getProfilePageData"
        );
        return null;
      });

    return response;
  }

  public static async fetchCenterPaneData(
    dashboardModel: DashboardModel
  ): Promise<any | null> {
    const response = await axios
      .post(process.env.REACT_APP_NUDGESAPIURL!, dashboardModel, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        logCustomInfo("fetchCenterPaneData Success", {
          RequestId: dashboardModel.RequestId,
        });
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in fetchCenterPaneData", {
          RequestId: dashboardModel.RequestId,
        });
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> fetchCenterPaneData"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> fetchCenterPaneData"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> fetchCenterPaneData"
          );
        }
        return null;
      });
    return response;
  }

  public static async generateADFSToken(): Promise<string> {
    const adfsTokenData = qs.stringify({
      grant_type: "client_credentials",
      client_id: process.env.REACT_APP_ADFSClientId,
      client_secret: process.env.REACT_APP_ADFSClientSecret,
      scope: process.env.REACT_APP_ADFSScope,
    });

    const adfsHeaders = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "Cache-Control":
        "no-cache, no-store, must-revalidate, post- check=0, pre-check=0",
      Pragma: "no-cache",
      Expires: "0",
    };

    const response = await axios
      .post(process.env.REACT_APP_ADFSEndpoint!, adfsTokenData, {
        headers: adfsHeaders,
      })
      .then((res: AxiosResponse<any>) => {
        localStorage.setItem("ADFSToken", res.data.access_token);
        return res.data.access_token;
      })
      .catch((error) => {
        logCustomError(error, "Error in generateADFSToken");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> generateADFSToken"
        );
      });

    return response;
  }

  public static async getADFSToken(): Promise<string | null> {
    var token: string | null;
    if (localStorage.getItem("ADFSToken") == null) {
      token = await ExternalApiService.generateADFSToken();
      localStorage.setItem("ADFSToken", token!);
    } else {
      token = localStorage.getItem("ADFSToken");
      let base46Value = token!.split(".")[1];
      var decodedValue = JSON.parse(window.atob(base46Value));
      var tokenDate = new Date(0);
      tokenDate.setUTCSeconds(decodedValue.exp);
      var currentTime = new Date();
      if (currentTime >= tokenDate) {
        token = await ExternalApiService.generateADFSToken();
        localStorage.setItem("ADFSToken", token!);
      }
    }

    return token;
  }

  public static async saveFeedbackThroughADFSToken(
    feedback: InputDetail,
    url: string
  ): Promise<Boolean> {
    var token = await ExternalApiService.getADFSToken();

    const axiosNewInstance = axios.create();
    axiosNewInstance.interceptors.request.use((config: any) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    const response = await axiosNewInstance
      .post(url, feedback, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<boolean>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in saveFeedbackThroughADFSToken");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> saveFeedbackThroughADFSToken"
        );
        return false;
      });
    return response;
  }

  public static async saveFeedback(
    feedback: InputDetail,
    url: string
  ): Promise<Boolean> {
    Utilities.LogInfo(
      JSON.stringify(feedback),
      "External-API.service.ts -> saveFeedback"
    );
    if (process.env.REACT_APP_ISDiPAADFSEnabled === "true")
      return ExternalApiService.saveFeedbackThroughADFSToken(feedback, url);
    else {
      const response = await axios
        .post(url, feedback, {
          headers: { ...this.getHeaders() },
        })
        .then((res: AxiosResponse<boolean>) => {
          return res.data;
        })
        .catch((error) => {
          logCustomError(error, "Error in saveFeedback");
          Utilities.LogError(
            JSON.stringify(error),
            "External-API.service.ts -> saveFeedback"
          );
          return false;
        });

      return response;
    }
  }

  public static async saveEmployeeFeedback(
    empfeedback: InputDetail,
    url: string
  ): Promise<Boolean> {
    Utilities.LogInfo(
      JSON.stringify(empfeedback),
      "External-API.service.ts -> saveFeedback"
    );
    if (process.env.REACT_APP_ISDiPAADFSEnabled === "true")
      return ExternalApiService.saveFeedbackThroughADFSToken(empfeedback, url);
    else {
      const response = await axios
        .post(url, empfeedback, {
          headers: { ...this.getHeaders() },
        })
        .then((res: AxiosResponse<boolean>) => {
          return res.data;
        })
        .catch((error) => {
          logCustomError(error, "Error in saveEmployeeFeedback");
          Utilities.LogError(
            JSON.stringify(error),
            "External-API.service.ts -> saveFeedback"
          );
          return false;
        });

      return response;
    }
  }

  public static async fetchPinnedCardsPaneData(
    emailId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_PERSONALIZATIONAPIURL!,
        { EnterpriseId: emailId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in fetchPinnedCardsPaneData");
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> fetchPinnedCardsPaneData"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> fetchPinnedCardsPaneData"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> fetchPinnedCardsPaneData"
          );
        }
        return null;
      });
    return response;
  }

    // Pinned Card Count Stared
    public static async fetchPinnedCardsCount(
      EnterpriseId: string
    ): Promise<any> {
      Utilities.LogInfo(
        JSON.stringify(this.fetchPinnedCardsCount),
        "External-API.service.ts -> fetchPinnedCardsCount"
      );
      const response = await axios
      .post(
        process.env.REACT_APP_FETCHPINNEDCARDCOUNT!,
        {
          EnterpriseId: EnterpriseId,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
        .then((res: AxiosResponse<any>) => {
          return res.data;
        })
        .catch((error) => {
          logCustomError(error, "Error in fetchPinnedCardsCount");
          Utilities.LogError(
            JSON.stringify(error),
            "External-API.service.ts -> fetchPinnedCardsCount"
          );
          return null;
        });
      return response;
    }
    // Pinned Card Count Ended

  public static async fetchRightPaneData(emailId: string): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_PERSONALIZATIONAPIURL!,
        { EnterpriseId: emailId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in fetchRightPaneData");
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> fetchRightPaneData"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> fetchRightPaneData"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> fetchRightPaneData"
          );
        }
        return null;
      });
    return response;
  }
  public static async fetchTAWUpcomingEvents(
    emailId: string
  ): Promise<any | null> {
    var startDate = new Date();
    var endDate = new Date(startDate);
    endDate.setFullYear(startDate.getFullYear() + 1);
    const response = await axios
      .post(
        process.env.REACT_APP_GETTAWUPCOMINGEVENTS!,
        { EnterpriseId: emailId,
          startDate: startDate,
          EndDate: endDate
         },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in fetchTAWUpcomingEvents");
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> fetchTAWUpcomingEvents"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> fetchTAWUpcomingEvents"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> fetchTAWUpcomingEvents"
          );
        }
        return null;
      });
    return response;
  }

  public static async saveUserPrefrences(
    emailId: string,
    id: string,
    isPinned: boolean
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_SAVEPERSONALIZATIONAPIURL!,
        {
          EnterpriseId: emailId,
          Id: id,
          IsPinned: isPinned,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        localStorage.setItem("apiFailed", "false");
        return res.data;
      })
      .catch((err) => {
        localStorage.setItem("apiFailed", "true");
        logCustomError(err, "err in saveUserPrefrences");
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> saveUserPrefrences"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> saveUserPrefrences"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> saveUserPrefrences"
          );
        }
        return null;
      });
    return response;
  }

  public static async trackAccelerationKitVisit(
    EmployeeEnterpriseId: string,
    SapId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_TRACKACCELERATIONKITVISIT!,
        {
          employeeEnterpriseId: EmployeeEnterpriseId,
          SapId: SapId
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        localStorage.setItem("apiFailed", "false");
        return res.data;
      })
      .catch((err) => {
        localStorage.setItem("apiFailed", "true");
        logCustomError(err, "err in tra");
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> trackAccelerationKitVisit"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> trackAccelerationKitVisit"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> trackAccelerationKitVisit"
          );
        }
        return null;
      });
    return response;
  }



  public static async fetchPeopleData(emailId: string): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETPEOPLEDETAIL!,
        { EmployeeEnterpriseId: emailId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> fetchPeopleData"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> fetchPeopleData"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> fetchPeopleData"
          );
        }
        return null;
      });
    return response;
  }

  public static async deleteUserCard(
    emailId: string,
    id: string
  ): Promise<boolean | null> {
    const response = await axios
      .post<boolean>(
        process.env.REACT_APP_DELETECARDURL!,
        {
          EnterpriseId: emailId,
          Id: id,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in deleteUserCard");
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> deleteUserCard"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> deleteUserCard"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> deleteUserCard"
          );
        }
        return null;
      });
    return response;
  }

  public static async getActiveUsersCountThroughADFSToken(): Promise<
    ActiveUsersCountModel[]
  > {
    var token = await ExternalApiService.getADFSToken();

    const axiosNewInstance = axios.create();
    axiosNewInstance.interceptors.request.use((config: any) => {
      config.headers.Authorization = `Bearer ${token}`;
      return config;
    });

    const response = await axiosNewInstance
      .get(process.env.REACT_APP_GETACTIVEUSERCOUNT!, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<any>) => {
        return res.data.value;
      })
      .catch((error) => {
        logCustomError(error, "Error in getActiveUsersCountThroughADFSToken");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getActiveUsersCountThroughADFSToken"
        );
        return false;
      });
    return response;

    //For Local Debugging enable the following response
    //return [{"Entity": "India.Technology","ReportDate": "2024-05-16T00:00:00Z","ActiveUsers": 68}];
  }

  public static async getActiveUsersCount(): Promise<ActiveUsersCountModel[]> {
    if (process.env.REACT_APP_ISDiPAADFSEnabled === "true")
      return ExternalApiService.getActiveUsersCountThroughADFSToken();
    else {
      const response = await axios
        .get(process.env.REACT_APP_GETACTIVEUSERCOUNT!)
        .then((res: AxiosResponse<any>) => {
          return res.data.value;
        })
        .catch((error) => {
          logCustomError(error, "Error in getActiveUsersCount");
          Utilities.LogError(
            JSON.stringify(error),
            "External-API.service.ts -> getActiveUsersCount"
          );
        });
        return response;

        //For Local Debugging enable the following response
        
        //return [{"Entity": "India.Technology","ReportDate": "2024-05-16T00:00:00Z","ActiveUsers": 68}];;
    }
  }

  public static async saveReminderData(
    remindValues: ReminderModel
  ): Promise<any | null> {
    localStorage.setItem("reminderCalled", "true");
    const response = await axios
      .post(process.env.REACT_APP_DASHBOARDREMINDERAPI!,
        {
          EmployeeEnterpriseId: remindValues.EmployeeEnterpriseId,
          CorrelationId: remindValues.CorrelationId,
          ReminderDateTime: remindValues.ReminderDateTime,
          ReminderDesc: remindValues.ReminderDesc,
          FirstName: remindValues.FirstName
        },
        {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in saveReminderData");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> saveReminderData"
        );
      });
    return response;
  }

  public static async saveCheckBoxOverlayData(
    checkBoxResponse: CheckBoxOverlayModel
  ): Promise<Boolean> {
    Utilities.LogInfo(
      JSON.stringify(checkBoxResponse),
      "External-API.service.ts -> saveCheckBoxOverlayData"
    );
    const response = await axios
      .post(process.env.REACT_APP_SETCHECKPINMESSAGEAPI!, checkBoxResponse, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<boolean>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in saveCheckBoxOverlayData");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> saveCheckBoxOverlayData"
        );
        return false;
      });
    return response;
  }

  public static async getCheckStateResponse(): Promise<Boolean> {
    const response = await axios
      .get(process.env.REACT_APP_GETCHECKPINMESSAGEAPI!)
      .then((res: AxiosResponse<any>) => {
        return res.data.checkState;
      })
      .catch((error) => {
        logCustomError(error, "Error in getCheckStateResponse");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getCheckStateResponse"
        );
      });
    return response;
  }

  public static async deleteReminderData(id: string): Promise<Boolean | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_DELETEREMINDER!,
        {
          correlationId: id,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in deleteReminderData");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> deleteReminderData"
        );
        return false;
      });
    return response;
  }

  public static async getEmployeeLog(
    emailid: string,
    careerLevel: string,
    doj: string
  ): Promise<nthUserModel | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETEMPLOYEELOG!,
        { EmployeeEnterpriseId: emailid, doj: doj, careerLevel: careerLevel },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in getEmployeeLog");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getEmployeeLog"
        );
      });
    return response;
  }

  public static async getRecommendations(): Promise<
    RecommendationDetailsModel[]
  > {
    var token = localStorage.getItem(Constants.AccessTokenKey);
    if (token != null) {
      const axiosNewInstance = axios.create();
      axiosNewInstance.interceptors.request.use((config: any) => {
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      });

      const response = await axiosNewInstance
        .post(
          process.env.REACT_APP_RECOMMENDATIONURL!,
          // { tokenData: localStorage.getItem(Constants.HumanApiTokenKey) },
          {
            headers: { ...this.getHeaders() },
          }
        )
        .then((res: AxiosResponse<any>) => {
          return res.data;
        })
        .catch((error) => {
          logCustomError(error, "Error in getRecommendationService");
          Utilities.LogError(
            JSON.stringify(error),
            "External-API.service.ts -> getRecommendationService"
          ); 
          return false;
        });
      return response; 
  } else return [];
  }

  //For Local Debugging enable the following response

  //return [{"employeeEnterpriseId": "samiksha.m.mone","connects": [{"employeeId": "11571690","employeeName": "Pulkit Arora","enterpriseId": "pulkit.h.arora","score": "72","scoreDetails": "MAL, Employee roll off date >= 90 days,Market,DU, Career Level 9 , ProjectName Matched, Primary Skill Matched, Skill Proficiency Matched, Primary Capability Matched, RoleFamily Matched,Market Unit Matched, WorkLocation Matched, Client Group(DG) Matched","profileImage": "data:image/png;base64,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"}]}];
    

  public static async getFile(): Promise<any | null> {
    const response = await axios
      .get(process.env.REACT_APP_DOWNLOADFILEDULNJR!, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in getFile");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getFile"
        );
      });
    return response;
  }
  public static async saveWhatsOnyourMindResponse(
    whatsOnYourMindResponse: WhatsOnYourMindModel
  ): Promise<Boolean> {
    Utilities.LogInfo(
      JSON.stringify(whatsOnYourMindResponse),
      "External-API.service.ts -> saveWhatsOnyourMindResponse"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_SETWHATONYOURMINDRESPONSEAPI!,
        whatsOnYourMindResponse,
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<boolean>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in saveWhatsOnyourMindResponse");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> saveWhatsOnyourMindResponse"
        );
        return false;
      });
    return response;
  }

  public static async SupervisorVIUpdate(
    zeroHourValues: viModel,
    url: string
  ): Promise<any | null> {
    const response = await axios
      .post(url, zeroHourValues, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in SupervisorVIUpdate");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> SupervisorVIUpdate"
        );
        return false;
      });
    return response;
  }

  public static async saveFeedbackData(
    feedbackValues: FeedbackModel,
    url: string
  ): Promise<any | null> {
    const response = await axios
      .post(url, feedbackValues, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in SaveFeedback");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> saveFeedbackData"
        );
        return false;
      });
    return response;
  }

  public static async getTrendingTopics(): Promise<any | null> {
    let token: any = "";
    if (process.env.REACT_APP_ISDiPAADFSEnabled === "true")
      token = await ExternalApiService.getADFSToken();
    else {
      token = localStorage.getItem(Constants.AccessTokenKey);
      if (token != null) {
        const axiosNewInstance = axios.create();
        axiosNewInstance.interceptors.request.use((config: any) => {
          config.headers.Authorization = `Bearer ${token}`;
          return config;
        });

        const response = await axiosNewInstance
          .get(process.env.REACT_APP_TRENDINGTOPCISURL!, {
            headers: { ...this.getHeaders() },
          })
          .then((res: AxiosResponse<any>) => {
            return res.data;
          })
          .catch((error) => {
            logCustomError(error, "Error in getTrendingTopics");
            Utilities.LogError(
              JSON.stringify(error),
              "External-API.service.ts -> getTrendingTopics"
            );
            return [];
          });

        return response;
        
      } else return [];
    }

    //For Local Debugging enable the following response

    //const response = [{ "intent": "AboutMe", "masterQuestions": [{ "masterQuestionSR": 1, "masterQuestion": "What is Workday" }, { "masterQuestionSR": 2, "masterQuestion": "Head of my DG" }, { "masterQuestionSR": 3, "masterQuestion": "What is my industry Group" }, { "masterQuestionSR": 4, "masterQuestion": "who is my supervisor" }, { "masterQuestionSR": 5, "masterQuestion": "I belong to which Delivery Unit" }, { "masterQuestionSR": 6, "masterQuestion": "my delivery group" }, { "masterQuestionSR": 7, "masterQuestion": "how can I find my Months at Level detail" }, { "masterQuestionSR": 8, "masterQuestion": "I would like to change my notification settings" }, { "masterQuestionSR": 9, "masterQuestion": "How do I get started on Workday" }, { "masterQuestionSR": 10, "masterQuestion": "who is my du lead" }] }, { "intent": "Tools", "masterQuestions": [{ "masterQuestionSR": 1, "masterQuestion": "Where can I see ethics and compliance training pending against my name" }, { "masterQuestionSR": 2, "masterQuestion": "attendance" }, { "masterQuestionSR": 3, "masterQuestion": "Daily Attendance" }, { "masterQuestionSR": 4, "masterQuestion": "how can I submit my attendance" }, { "masterQuestionSR": 5, "masterQuestion": "how to submit my attendance" }, { "masterQuestionSR": 6, "masterQuestion": "None of these" }] }, { "intent": "Leaves", "masterQuestions": [{ "masterQuestionSR": 1, "masterQuestion": "What is a Caregiver Leave" }, { "masterQuestionSR": 2, "masterQuestion": "What is my sick leave balance" }, { "masterQuestionSR": 3, "masterQuestion": "what is my vacation balance" }, { "masterQuestionSR": 4, "masterQuestion": "What is Secondary Caregiver leave and the process for the same" }, { "masterQuestionSR": 5, "masterQuestion": "hello" }, { "masterQuestionSR": 6, "masterQuestion": "hi" }, { "masterQuestionSR": 7, "masterQuestion": "my sick leave details" }, { "masterQuestionSR": 8, "masterQuestion": "sick leave" }] }, { "intent": "IJP", "masterQuestions": [{ "masterQuestionSR": 1, "masterQuestion": "open roles for me" }, { "masterQuestionSR": 2, "masterQuestion": "open roles" }, { "masterQuestionSR": 3, "masterQuestion": "Is there any limit to the number of roles that I can apply for" }, { "masterQuestionSR": 4, "masterQuestion": "MAL" }, { "masterQuestionSR": 5, "masterQuestion": "R2481158" }, { "masterQuestionSR": 6, "masterQuestion": "R2690062" }, { "masterQuestionSR": 7, "masterQuestion": "R2814455" }, { "masterQuestionSR": 8, "masterQuestion": "What is status of my applications" }, { "masterQuestionSR": 9, "masterQuestion": "What is the eligibility criteria to apply for IJP roles" }] }, { "intent": "Benefits and Reimbursements", "masterQuestions": [{ "masterQuestionSR": 1, "masterQuestion": "How will E C noncompliance impact rewards decisions" }, { "masterQuestionSR": 2, "masterQuestion": "How will medical insurance claims be settled when the claims are directly submitted by the employee" }, { "masterQuestionSR": 3, "masterQuestion": "Will the Variable Pay payout percentage be same for both Dec 17 and June 18" }, { "masterQuestionSR": 4, "masterQuestion": "How can I get reimbursement for RT PCR testing" }, { "masterQuestionSR": 5, "masterQuestion": "My supervisor mentioned my comp increase is based on my gap from market pay What does that imply" }, { "masterQuestionSR": 6, "masterQuestion": "None of these" }, { "masterQuestionSR": 7, "masterQuestion": "salary" }, { "masterQuestionSR": 8, "masterQuestion": "What are the factors that affect my hike" }] }];

    //return response;
  }
  public static async HolidayDetails(
    enterpriseId: string,
    location: any
  ): Promise<any> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETHOLIDAYDETAILS!,
        { EmployeeEnterpriseId: enterpriseId, WorkLocation: location },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> HolidayDetails"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> HolidayDetails"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> HolidayDetails"
          );
        }
        return true;
      });

    return response;
    //  const response  = [{"employeeEnterpriseId":"balasaheb.wadd","lstMandatoryHolidays":[{"holiday":"New Year's Day3","holidaytype":"Mandatory","holidaytypeDate":"08-Dec-21"},{"holiday":"New Year's Day2","holidaytype":"Mandatory","holidaytypeDate":"08-Dec-21"}],"lstFloatingHolidays":[{"holiday":"Vijaya Dasami","holidaytype":"Floating","holidaytypeDate":"09-Dec-21"}]}];
    //  return response;
  }
  public static async GetLeaveDetails(sapId: any): Promise<any> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETLEAVEDETAILS!,
        { InputDetail: { PersonnelNumber: sapId } },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (err.response) {
          Utilities.LogError(
            JSON.stringify(err.response),
            "External-API.service.ts -> GetLeaveDetails"
          );
        } else if (err.request) {
          Utilities.LogError(
            JSON.stringify(err.request),
            "External-API.service.ts -> GetLeaveDetails"
          );
        } else {
          Utilities.LogError(
            JSON.stringify(err),
            "External-API.service.ts -> GetLeaveDetails"
          );
        }
        return false;
      });
    return response;
    // const response  = {"@odata.context":"https://wa-7364-dpa-dev1.ase2-dev-paas.p.azurewebsites.net/ExternalAPIServices-service/$metadata#Accenture.CIO.DiPA.ExternalAPICore.Entities.ASTEntity","Id":null,"ExitRequestId":null,"ExitDate":null,"RequestedLastWorkingDay":null,"ApprovedLastWorkingDay":null,"TransferRequestId":null,"RequestTransferDate":null,"ApprovedTransferDate":null,"TransferRequestApprovedBy":null,"Message":null,"DaysLeftForLastWorkingDay":null,"ExitBackDate":null,"SickAndVacationLeaveDetail":{"VacationLeaveBalanceInDays":"32.66","VacationLeaveBalanceInHours":"294.00","SickLeaveBalanceInDays":"6.00","SickLeaveBalanceInHours":"54.00","VacationLeaveAvailedInDays":"9.00","VacationLeaveAvailedInHours":"81.00","SickLeaveAvailedInDays":"1.00","SickLeaveAvailedInHours":"9.00"},"ChecklistStatusDetails":[],"NoticePeriodDetail":null,"ExitProcessApprove":[],"OrganizationalChart":[],"ODSPeopleAccrualsPTO":null};
    // const response=null;
    // return response;
  }
  public static async getEmployeeCoordinatesDetails(
    enterpriseId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_EmployeeCoordinateURL!,
        { EmployeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getEmployeeCoordinatesDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getEmployeeCoordinatesDetails"
        );
        return false;
      });

    return response;
    //     const response={"id":0,"countryName":null,"peopleKey":0,"enterpriseId":null,"personnelNumber":"13008398","careerCounselorID":null,"careerCounselorName":"sunny.a.verma","supervisorName":"sunny.a.verma","supervisorID":null,"hrRepName":"dharini.narayan","hrRepID":null,"mostRecentHireDate":"11/6/2020","standardJobAbbreviation":null,"employeeName":null,"firstName":"Kunal","middleName":null,"lastName":null,"dateOfJoining":null,"message":null,"employmentStatusDescription":null,"metroCityDescription":null,"jobCodeDescription":"11","duName":"ATCI-Emp-Exp","totalTenure":0,"dgName":"CIOHR-TSC","acgName":"CIO","crossWorkforceCareerLevelDescription":"Analyst","talentSegmentDescription":"Software Engineering","specialtyDescription":"","careerTrackDescription":"Client Delivery & Operations","careerLevel":"11 - Analyst","monthsAtLevelNumber":null,"lastPromotionDate":null,"orgUnitId":"58178276","agLeadEnterpriseID":"roopa.bhongade","dgLeadEnterpriseID":"ashok.vira","duLeadEnterpriseID":"shubha.ramakrishnan"};
    // return  response;
  }
  public static async saveNewJoinerSurveyResponse(
    newJoinerJourney: newJoinerJourneySurveyModel,
    url: string
  ): Promise<any | null> {
    const response = await axios
      .post(url, newJoinerJourney, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in saveNewJoinerSurveyResponse");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> saveNewJoinerSurveyResponse"
        );
        return false;
      });
    return response;
  }
  public static async saveGamificationWeeklyPreQuizResponse(
    weeklyQuizResponse: gamificationWeeklyQuizModel,
    url: string
  ): Promise<gamificationWeeklyQuizResponseModel | null> {
    const response = await axios
      .post(url, weeklyQuizResponse, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in saveGamificationWeeklyPreQuizResponse");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> saveGamificationWeeklyPreQuizResponse"
        );
        return false;
      });
    return response;
  }
  public static async saveGamificationWeeklyQuizResponse(
    weeklyQuizResponse: gamificationWeeklyQuizModel,
    url: string
  ): Promise<gamificationWeeklyQuizResponseModel | null> {
    const response = await axios
      .post(url, weeklyQuizResponse, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in saveGamificationWeeklyQuizResponse");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> saveGamificationWeeklyQuizResponse"
        );
        return false;
      });
    return response;
  }

  public static async saveNewJoinerCheckListResponse(
    newJoinerChecklist: newJoinerChecklistModel,
    url: string
  ): Promise<any | null> {
    const response = await axios
      .post(url, newJoinerChecklist, {
        headers: { ...this.getHeaders() },
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in saveNewJoinerCheckListResponse");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> saveNewJoinerCheckListResponse"
        );
        return false;
      });
    return response;
  }

  public static async getNewJourneySurveyDetails(
    enterpriseId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETNEWJOINERSURVEYDETAILS!,
        {
          EmployeeEnterpriseId: enterpriseId,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getNewJourneySurveyDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getNewJourneySurveyDetails"
        );
        return false;
      });
    // const response = { "employeeEnterpriseId": "kunal.d.agarwal", "isonboarding": false, "isonboardingSurvey": false, "isOrientation": false, "isOrientationSurvey": false, "isHrConnect": false, "isHrConnectSurvey": false, "isTraining": false, "isTrainingSurvey": false, "isfirstProject": false, "isfirstProjectSurvey": false, "isSurveyCompleted": false }

    return response;
  }
  public static async getNewJoinerCheckListDetails(
    enterpriseId: string
  ): Promise<any | null> {
    var response = await axios
      .post(
        process.env.REACT_APP_GETNEWJOINERCHECKLISTDETAILS!,
        { EmployeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getNewJoinerCheckListDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getNewJoinerCheckListDetails"
        );
        return false;
      });
      //return {"NJCL1":true,"NJCL2":true,"NJCL3":false,"NJCL4":false,"NJCL5":false,"NJCL6":false,"NJCL7":false,"NJCL8":false,"NJCL9":false,"NJCL10":false,"NJCL11":false,"NJCL12":false}
      return response;
  }

  public static async saveROvEMployee(
    ROVEmployeeResponse: RovApplyModel
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(ROVEmployeeResponse),
      "External-API.service.ts -> saveROvEMployee"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_ApplyForIJPDemandRoleAPI!,
        ROVEmployeeResponse,
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in saveROvEMployee");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> saveROvEMployee"
        );
        return false;
      });
    return response;
  }

  public static async getRovEmployee(
    enterpriseId: string,
    location: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETROVIJPDETAILS!,
        { EmployeeEnterpriseId: enterpriseId, Location: location },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getEmployeeCoordinatesDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getEmployeeCoordinatesDetails"
        );
        return null;
      });

    return response;
    //const response = [{ "demandMessage": null, "demandEntity": { "demandNo": "2541981", "demand_No": "R2541981", "demandClientRequirementStartDate": "10/10/2019", "demandOfficeLocationName": "Mumbai", "demandAccountGroup": "AVANADE", "demandPrimarySkill": "ASP.NET MVC", "demandPrimarySKillID": 53911, "jdkeyword_Desc": "Role :\r\nApplication Developer\r\n\r\nRole Description :\r\nDesign, build and configure applications to meet business process and application requirements.                                                                                                                                                                                                                                                                                                                                                                                                                                              \r\n\r\nMust Have Skills :\r\nASP.NET MVC,No Industry Specialty\r\n\r\nGood To Have Skills :\r\n\r\n\r\nJob Requirements :\r\nKey Responsibilities:\r\na.\tResource should have Strong knowledge on Asp.Net  MVC  WebAPI  SQLb. Resource should have experience on Web Service  Angular 2  HTML   CSS3  Bootstrapc. Identifies troubleshoots n documents application n process issues.d. Initiates major changes in architecture and software development techniques and processes.\r\n\r\nTechnical Experience:\r\nMandatay skill should be Asp.Net  MVC  WebAPI  SQL.  Web Service  Angular JS  HTML and CSS3 Bootstrap\r\n\r\nProfessional Experience:\r\nA:Good verbal n written communication skills to connect with customers at varying levels of the organizationB: Ability to operate independently and make decisions with little direct supervision\r\n\r\nEducational Qualification:\r\nShould be Graduate\r\n\r\nAdditional Information:\r\n\r\n\r\n", "careerLevel": "11", "iJP_Resources": 2, "demandAssignedRole": "Application Developer", "demandSpecialist": "N" } }, { "demandMessage": null, "demandEntity": { "demandNo": "2799707", "demand_No": "R2799707", "demandClientRequirementStartDate": "09/15/2020", "demandOfficeLocationName": "Mumbai", "demandAccountGroup": "AVANADE", "demandPrimarySkill": "Agile Management Resources", "demandPrimarySKillID": 53911, "jdkeyword_Desc": "Role :\r\n  Application Developer\r\n  \r\n  Role Description :\r\n  Design, build and configure applications to meet business process and application requirements.                                                                                                                                                                                                                                                                                                                                                                                                                                              \r\n  \r\n  Must have Skills :\r\n  ASP.NET MVC\r\n  \r\n  Good to Have Skills :\r\n   AWS Architecture, Angular\r\n  \r\n  Job Requirements :\r\n  Key Responsibilities :\r\n  Ability to grasp information and requirements quickly  \tShould be able to guide and resolve junior team members queries in case of SSE \tProvide inputs on Data architecture and design for the same \tGood Troubleshooting skills, Problem solving mindset\r\n  \r\n  Technical Experience :\r\n  ASpNet, MVC Angular MS SQL Server  Good To Have - Microservices/Containers - \tAWS Technologies : API Gateway, EKS, ECR, MSK, Aurora, KMS, Secret Manager, X Ray, Cognito -\r\n  \r\n  Professional Attributes :\r\n  Very good in requirement understanding, written and verbal communication, exposure to work in onshore -offshore model\r\n  \r\n  Educational Qualification:\r\n  \r\n  \r\n  Additional Info :", "careerLevel": "11", "iJP_Resources": 1, "demandAssignedRole": "Application Developer", "demandSpecialist": "N" } }]
    //const items = [{ "demandMessage": null, "demandEntity": { "demandNo": "2541981", "demand_No": "R2541981", "demandClientRequirementStartDate": "10/10/2019", "demandOfficeLocationName": "Mumbai", "demandAccountGroup": "AVANADE", "demandPrimarySkill": "ASP.NET MVC", "demandPrimarySKillID": 53911, "jdkeyword_Desc": "Role :\r\nApplication Developer\r\n\r\nRole Description :\r\nDesign, build and configure applications to meet business process and application requirements.                                                                                                                                                                                                                                                                                                                                                                                                                                              \r\n\r\nMust Have Skills :\r\nASP.NET MVC,No Industry Specialty\r\n\r\nGood To Have Skills :\r\n\r\n\r\nJob Requirements :\r\nKey Responsibilities:\r\na.\tResource should have Strong knowledge on Asp.Net  MVC  WebAPI  SQLb. Resource should have experience on Web Service  Angular 2  HTML   CSS3  Bootstrapc. Identifies troubleshoots n documents application n process issues.d. Initiates major changes in architecture and software development techniques and processes.\r\n\r\nTechnical Experience:\r\nMandatay skill should be Asp.Net  MVC  WebAPI  SQL.  Web Service  Angular JS  HTML and CSS3 Bootstrap\r\n\r\nProfessional Experience:\r\nA:Good verbal n written communication skills to connect with customers at varying levels of the organizationB: Ability to operate independently and make decisions with little direct supervision\r\n\r\nEducational Qualification:\r\nShould be Graduate\r\n\r\nAdditional Information:\r\n\r\n\r\n", "careerLevel": "11", "iJP_Resources": 2, "demandAssignedRole": "Application Developer", "demandSpecialist": "N" } }, { "demandMessage": null, "demandEntity": { "demandNo": "2799707", "demand_No": "R2799707", "demandClientRequirementStartDate": "09/15/2020", "demandOfficeLocationName": "Mumbai", "demandAccountGroup": "AVANADE", "demandPrimarySkill": "Agile Management Resources", "demandPrimarySKillID": 53911, "jdkeyword_Desc": "Role :\r\n  Application Developer\r\n  \r\n  Role Description :\r\n  Design, build and configure applications to meet business process and application requirements.                                                                                                                                                                                                                                                                                                                                                                                                                                              \r\n  \r\n  Must have Skills :\r\n  ASP.NET MVC\r\n  \r\n  Good to Have Skills :\r\n   AWS Architecture, Angular\r\n  \r\n  Job Requirements :\r\n  Key Responsibilities :\r\n  Ability to grasp information and requirements quickly  \tShould be able to guide and resolve junior team members queries in case of SSE \tProvide inputs on Data architecture and design for the same \tGood Troubleshooting skills, Problem solving mindset\r\n  \r\n  Technical Experience :\r\n  ASpNet, MVC Angular MS SQL Server  Good To Have - Microservices/Containers - \tAWS Technologies : API Gateway, EKS, ECR, MSK, Aurora, KMS, Secret Manager, X Ray, Cognito -\r\n  \r\n  Professional Attributes :\r\n  Very good in requirement understanding, written and verbal communication, exposure to work in onshore -offshore model\r\n  \r\n  Educational Qualification:\r\n  \r\n  \r\n  Additional Info :", "careerLevel": "11", "iJP_Resources": 1, "demandAssignedRole": "Application Developer", "demandSpecialist": "N" } }]

    // const response={"id":0,"countryName":null,"peopleKey":0,"enterpriseId":null,"personnelNumber":"13008398","careerCounselorID":null,"careerCounselorName":"sunny.a.verma","supervisorName":"sunny.a.verma","supervisorID":null,"hrRepName":"dharini.narayan","hrRepID":null,"mostRecentHireDate":"11/6/2020","standardJobAbbreviation":null,"employeeName":null,"firstName":"Kunal","middleName":null,"lastName":null,"dateOfJoining":null,"message":null,"employmentStatusDescription":null,"metroCityDescription":null,"jobCodeDescription":"11","duName":"ATCI-Emp-Exp","totalTenure":0,"dgName":"CIOHR-TSC","acgName":"CIO","crossWorkforceCareerLevelDescription":"Analyst","talentSegmentDescription":"Software Engineering","specialtyDescription":"","careerTrackDescription":"Client Delivery & Operations","careerLevel":"11 - Analyst","monthsAtLevelNumber":null,"lastPromotionDate":null,"orgUnitId":"58178276","agLeadEnterpriseID":"roopa.bhongade","dgLeadEnterpriseID":"ashok.vira","duLeadEnterpriseID":"shubha.ramakrishnan"};
    //return items;
  }

  public static async getGamificationQuizDetails(
    enterpriseId: string,
    trainingStartDate: any,
    trainingEndDate: any
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETGAMIFICATIONQUIZDETAILS!,
        {
          EmployeeEnterpriseId: enterpriseId,
          TrainingStartDate: trainingStartDate,
          TrainingEndDate: trainingEndDate,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getGamificationQuizDetails");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getGamificationQuizDetails"
        );
        return true;
      });
    return response;
  }

  public static async getGamificationScore(
    enterpriseId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETGAMIFICATIONSCOREDETAILS!,
        { employeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getGamificationScore");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getGamificationScore"
        );
        return false;
      });
    return response;
  }

  public static async getGamificationFAQ(): Promise<any | null> {
    const response = await axios
      .get(process.env.REACT_APP_GETGAMIFICATIONFAQ!, {
        headers: { ...this.getHeaders() },
      })
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getGamificationScore");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getGamificationScore"
        );
        return false;
      });
    return response;
  }

  public static async getIndividualTabDetails(
    IndividualTabDetailsRequestModel: individualTabDetailsRequestModel
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETINDIVIDUALTABDETAILS!,
        IndividualTabDetailsRequestModel,
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in getIndividualTabDetails");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getIndividualTabDetails"
        );
        return [];
      });
    return response;
  }
  public static async getBadgeSectionDetails(
    enterpriseId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETBADGESECTIONDETAILS!,
        { employeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getBadgeSectionDetails");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getBadgeSectionDetails"
        );
        return [];
      });
    return response;
  }
  public static async getCohortTabDetails(
    CohortTabDetailsRequestModel: cohortTabDetailsRequestModel
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETCOHORTTABDETAILS!,
        CohortTabDetailsRequestModel,
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "Error in getCohortTabDetails");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getCohortTabDetails"
        );
        return [];
      });
    return response;
  }

  public static async getPointHistoryTabDetails(
    enterpriseId: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETPOINTHISTORYTABDETAILS!,
        { employeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getPointHistoryTabDetails");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getPointHistoryTabDetails"
        );
        return [];
      });
    return response;
  }

  public static async getIsGamificationPilotUser(
    enterpriseId: string
  ): Promise<any> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETISGAMIFICATIONPILOTUSER!,
        { employeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getIsGamificationPilotUser");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getIsGamificationPilotUser"
        );
        return null;
      });
    return response;
  }
  public static async getGamificationReviewQuizDetails(
    enterpriseId: string,
    quizName: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETGAMIFICATIONREVIEWQUIZDETAILS!,
        {
          EmployeeEnterpriseId: enterpriseId,
          QuizName: quizName,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getGamificationQuizDetails");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getGamificationQuizDetails"
        );
        return true;
      });
    return response;
  }

  public static async getIsGamificationQuizValid(
    enterpriseId: string
  ): Promise<any> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETISGAMIFICATIONQUIZVALID!,
        { employeeEnterpriseId: enterpriseId },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getIsGamificationQuizValid");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getIsGamificationQuizValid"
        );
        return null;
      });
    return response;
  }

  public static async saveFaqMetricsData(
    enterpriseId: string,
    metricsType: string,
    tag: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.saveFaqMetricsData),
      "External-API.service.ts -> saveFaqMetricsData"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_SAVEMETRICSDATA!,
        {
          employeeEnterpriseId: enterpriseId,
          type: metricsType,
          tag: tag,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in saveFaqMetricsData");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> saveFaqMetricsData"
        );
        return false;
      });
    return response;
  }

  public static async saveDigitalWorkerFaqMetricsData(
    enterpriseId: string,
    metricsType: string,
    tag: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.saveDigitalWorkerFaqMetricsData),
      "External-API.service.ts -> saveDigitalWorkerFaqMetricsData"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_SAVEMETRICSDATA!,
        {
          employeeEnterpriseId: enterpriseId,
          type: metricsType,
          tag: tag,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in saveDigitalWorkerFaqMetricsData");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> saveDigitalWorkerFaqMetricsData"
        );
        return false;
      });
    return response;
  }

  public static async getSaveMetricsDetails(
    enterpriseId: string,
    metricsType: string,
    tag: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.getSaveMetricsDetails),
      "External-API.service.ts -> getSaveMetricsDetails"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_SAVEMETRICSDATA!,
        {
          employeeEnterpriseId: enterpriseId,
          type: metricsType,
          tag: tag,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getSaveMetricsDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getSaveMetricsDetails"
        );
        return null;
      });
    return response;
  }
  public static async getDigitalWorkerFAQ(tag: string): Promise<any> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETDIGITALWORKERFAQ!,
        {
          faqId: tag,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: { data: any }) => {
        return res.data;
      })
      .catch((err: any) => {
        logCustomError(err, "Error in getDigitalWorkerFAQ");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getDigitalWorkerFAQ"
        );
        return false;
      });
    return response;
  }

  public static async getCheckAccess(enterpriseId: string): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.getCheckAccess),
      "External-API.service.ts -> getCheckAccess"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_CHECKMETRICSACCESS!,
        {
          EmployeeEnterpriseId: enterpriseId,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getCheckAccess");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getCheckAccess"
        );
        return false;
      });
    return response;
  }

  public static async getDashboardMetricsReport(
    startDate: string,
    endDate: string,
    metricsId: string,
    isReportRequired: boolean
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.getDashboardMetricsReport),
      "External-API.service.ts -> getDashboardMetricsReport"
    );
    const response = await axios
      .post(
        process.env.REACT_APP_GENERATEDASHBOARDMETRICSREPORT!,
        {
          startTime: startDate,
          endTime: endDate,
          metricsId: metricsId,
          isReportRequired: isReportRequired,
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res;
      })
      .catch((error) => {
        logCustomError(error, "Error in getDashboardMetricsReport");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getDashboardMetricsReport"
        );
        return false;
      });
    return response;
  }

  public static async getDashboardMetricsDetails(): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.getDashboardMetricsDetails),
      "External-API.service.ts -> getDashboardMetricsDetails"
    );
    const response = await axios
      .get(process.env.REACT_APP_GETDASHBOARDMETRICSDETAILS!, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<any>) => {
        return res;
      })
      .catch((error) => {
        logCustomError(error, "Error in getDashboardMetricsDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getDashboardMetricsDetails"
        );
        return false;
      });
    return response;
  }

  public static async getBuddyDetails(): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.getBuddyDetails),
      "External-API.service.ts -> getBuddyDetails"
    );
    const response = await axios
      .get(process.env.REACT_APP_GETBUDDYDETAILS!, {
        headers: { ...this.getHeaders() },
      })
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getBuddyDetails");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getBuddyDetails"
        );
        return false;
      });
    return response;
  }

  public static async fetchSharedCard(
    EnterpriseId: string,
    isActiveModal: string,
    isOnLoad: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.fetchSharedCard),
      "External-API.service.ts -> fetchSharedCard"
    );
    const response = await axios
    .post(
      process.env.REACT_APP_FETCHSHAREDCARD!,
      {
        EnterpriseId: EnterpriseId,
        isActiveModal: isActiveModal,
        isOnLoad: isOnLoad,
      },
      {
        headers: { ...this.getHeaders() },
      }
    )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in fetchSharedCard");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> fetchSharedCard"
        );
        return null;
      });
    return response;
  }

  public static async fetchSharedCardCount(
    EnterpriseId: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.fetchSharedCardCount),
      "External-API.service.ts -> fetchSharedCardCount"
    );
    const response = await axios
    .post(
      process.env.REACT_APP_FETCHSHAREDCARDCOUNT!,
      {
        EnterpriseId: EnterpriseId,
      },
      {
        headers: { ...this.getHeaders() },
      }
    )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in fetchSharedCardCount");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> fetchSharedCardCount"
        );
        return null;
      });
    return response;
  }

  public static async updateSharedCard(
    toEnterpriseId: string,
    createdDate: string,
    isActiveModal: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.updateSharedCard),
      "External-API.service.ts -> updateSharedCard"
    );
    const response = await axios
    .post(
      process.env.REACT_APP_UPDATESHAREDCARDDATA!,
      {
        toEnterpriseId: toEnterpriseId,
        createdDate: createdDate,
        isActiveModal: isActiveModal
      },
      {
        headers: { ...this.getHeaders() },
      }
    )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in updateSharedCard");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> updateSharedCard"
        );
        return false;
      });
    return response;
  }

  public static async sharedCardEmail(
    FromEnterpriseId: string,
    ToEnterpriseId: string,
    CardId: string,
    CardExpiryDate: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.sharedCardEmail),
      "External-API.service.ts -> sharedCardEmail"
    );
    const response = await axios
    .post(
      process.env.REACT_APP_SHAREDCARDEMAIL!,
      {
        FromEnterpriseId: FromEnterpriseId,
        ToEnterpriseId: ToEnterpriseId,
        CardId: CardId,
        CardExpiryDate: CardExpiryDate
      },
      {
        headers: { ...this.getHeaders() },
      }
    )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in sharedCardEmail");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> sharedCardEmail"
        );
        return false;
      });
    return response;
  }

  public static async getExperienceManagerDetails(
    candidateEnterpriseId: string
  ): Promise<any> {
    Utilities.LogInfo(
      JSON.stringify(this.getExperienceManagerDetails),
      "External-API.service.ts -> getExperienceManagerDetails"
    );
    var token = localStorage.getItem(Constants.AccessTokenKey);
    if (token != null) {
      const axiosNewInstance = axios.create();
      axiosNewInstance.interceptors.request.use((config: any) => {
        config.headers.Authorization = `Bearer ${token}`;
        return config;
      });
      const response = await axios
        .post(
          process.env.REACT_APP_GETEXPERIENCEMANAGERDETAILS!,
          {
            candidateEnterpriseId: candidateEnterpriseId,
            //tokenData: localStorage.getItem(Constants.HumanApiTokenKey),
          },
          {
            headers: { ...this.getHeaders() },
          }
        )
        .then((res: AxiosResponse<any>) => {
          return res.data;
        })
        .catch((error) => {
          logCustomError(error, "Error in getExperienceManagerDetails");
          Utilities.LogError(
            JSON.stringify(error),
            "External-API.service.ts -> getExperienceManagerDetails"
          );
          return false;
        });
      return response;
    } else 
    return [];
  }
    
public static async getEmployeeDesignation(
    emailid: string
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_GETEMPLOYEEDESIGNATION!,
        { EmployeeEnterpriseId: emailid },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in getEmployeeLog");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> getEmployeeLog"
        );
      });
    return response;

    //For Local Debugging enable the following response

    //return [{"isSuccess": true,"designation": "Custom Software Engineering Analyst","message": "Successfully executed"}];
    
  }

  public static async deleteSharedCard(
    EnterpriseId: string,
    CardId: string,
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_DELETESHAREDCARDAPI!,
        { 
          EnterpriseId: EnterpriseId,
          CardId: CardId
         },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in deleteSharedCard");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> deleteSharedCard"
        );
      });
    return response;
  }

  public static async pinnedSharedCard(
    EnterpriseId: string,
    CardId: string,
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_PINNEDSHAREDCARDAPI!,
        { 
          EnterpriseId: EnterpriseId,
          CardId: CardId
         },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in pinnedSharedCard");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> pinnedSharedCard"
        );
      });
    return response;
  }

  public static async reminderSharedCard(
    EmployeeEnterpriseId: string,
    CorrelationId: string | undefined,
    ReminderDateTime: string | undefined,
    ReminderDesc: string | undefined,
    FirstName: string | undefined,
  ): Promise<any | null> {
    localStorage.setItem("reminderCalled", "true");
    const response = await axios
      .post(
        process.env.REACT_APP_SHAREDCARDREMINDERAPI!,
        { 
          EmployeeEnterpriseId: EmployeeEnterpriseId,
          CorrelationId: CorrelationId,
          ReminderDateTime: ReminderDateTime,
          ReminderDesc: ReminderDesc,
          FirstName: FirstName
         },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in reminderSharedCard");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> reminderSharedCard"
        );
      });
    return response;
  }

  public static async unPinSharedCard(
    EnterpriseId: string,
    CardId: string,
  ): Promise<any | null> {
    const response = await axios
      .post(
        process.env.REACT_APP_UNPINSHAREDCARDAPI!,
        { 
          EnterpriseId: EnterpriseId,
          CardId: CardId
         },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((err) => {
        logCustomError(err, "err in unPinSharedCard");
        Utilities.LogError(
          JSON.stringify(err),
          "External-API.service.ts -> unPinSharedCard"
        );
      });
    return response;
  }

// Fetch Employee Feedback Stared
public static async fetchEmployeeFeedback(
  EnterpriseId: string
): Promise<any> {
  Utilities.LogInfo(
    JSON.stringify(this.fetchEmployeeFeedback),
    "External-API.service.ts -> fetchEmployeeFeedback"
  );
  const response = await axios
  .post(
    process.env.REACT_APP_FETCHEMPLOYEEFEEDBACK!,
    {
      EnterpriseId: EnterpriseId,
    },
    {
      headers: { ...this.getHeaders() },
    }
  )
    .then((res: AxiosResponse<any>) => {
      return res.data;
    })
    .catch((error) => {
      logCustomError(error, "Error in fetchEmployeeFeedback");
      Utilities.LogError(
        JSON.stringify(error),
        "External-API.service.ts -> fetchEmployeeFeedback"
      );
      return null;
    });
  return response;
}
// Fetch Employee Feedback Ended

// Get Employee HRPA Details Started
public static async getProfilePic(
  buddyId: string,
  hRPAId: string,
  pLId: string,
  eMId: string,
): Promise<any> {
  Utilities.LogInfo(
    JSON.stringify(this.getProfilePic),
    "External-API.service.ts -> getProfilePic"
  );
    const response = await axios
      .post(
        process.env.REACT_APP_GETPROFILEPIC!,
        {
          buddyId: buddyId,
          hRPAId: hRPAId,
          pLId: pLId,
          emId: eMId,
          //tokenData: localStorage.getItem(Constants.HumanApiTokenKey),
        },
        {
          headers: { ...this.getHeaders() },
        }
      )
      .then((res: AxiosResponse<any>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getProfilePic");
        Utilities.LogError(
          JSON.stringify(error),
          "External-API.service.ts -> getProfilePic"
        );
        return null;
      });
    return response;
 }
 // Get Employee HRPA Details Ended
 
public static async getBuddyAknowledments(
  employeeEnterpriseId: string,
): Promise<any | null> {
    const response = await axios
    .post(process.env.REACT_APP_BUDDYACKNOWLEDMENTS!,
        {employeeEnterpriseId }, // POST body (JSON)
        {
          headers: { ...this.getHeaders() }, // Include headers
        })
      .then((res: AxiosResponse<WTADetailedData>) => {
        return res.data;
      })
      .catch((error) => {
        logCustomError(error, "Error in getBuddyAknowledments");
        return null;
      });
    return response;
  }
  
  //api to fetch all test ids
  public static getTestIds(userEmail: string): any {
      const response = axios
      .post(
        process.env.REACT_APP_GETTESTIDINFO!,
        { EmployeeEnterpriseId: userEmail },
        {
          headers: { ...this.getHeaders() },
        }
        )
        .then((res: AxiosResponse<any>) => {
          return res.data;
        })
        .catch((error) => {
          logCustomError(error, "Error in getTestIds");
          return null;
        });
      return response;
    }
  
    public static async getPLHRPAAknowledments(
      employeeEnterpriseId: string,
    ): Promise<any | null> {
        const response = await axios
        .post(process.env.REACT_APP_PLHRPAACKNOWLEDMENTS!,
          { employeeEnterpriseId }, // POST body (JSON)
          {
            headers: { ...this.getHeaders() },  // Include headers
          })
          .then((res: AxiosResponse<WTADetailedData>) => {
            return res.data;
          })
          .catch((error) => {
            logCustomError(error, "Error in getPLHRPAAknowledments");
            return null;
          });
        return response;
      }

    public static getGetChecklistPopUpFlag(EmployeeEnterpriseId: string, dismissalValue : string, doj : string): any {
       const response = axios
       .post(
         process.env.REACT_APP_GETNJCHECKLISTPOPUPFLAG!,
         { 
           EmployeeEnterpriseId: EmployeeEnterpriseId,
           dismissalValue: dismissalValue,
           doj: doj,
          },
         {
           headers: { ...this.getHeaders() },
         }
         )
         .then((res: AxiosResponse<any>) => {
           return res.data;
         })
         .catch((error) => {
           logCustomError(error, "Error in getGetChecklistPopUpFlag");
           return null;
         });
      return response;
    }

    public static getGetChecklistPopUpVisibility(EmployeeEnterpriseId: string, doj : string): any {
       const response = axios
       .post(
         process.env.REACT_APP_GETNJCHECKLISTPOPUPVISIBILITY!,
         { 
           EmployeeEnterpriseId: EmployeeEnterpriseId,
           doj: doj,
          },
         {
           headers: { ...this.getHeaders() },
         }
         )
         .then((res: AxiosResponse<any>) => {
           return res.data;
         })
         .catch((error) => {
           logCustomError(error, "Error in getGetChecklistPopUpVisibility");
           return null;
         });
      return response;
    }
}

ExternalApiService.initialize();
